// Модули, которые должны быть подключены на всех страницах.

import "./marketing/newsletter";
import "./marketing/refs";
import "./components/attention";
import "./components/main";
import "./components/messages";
import "./components/scrolling";
import "./components/signin";
import "./components/suggestions";
import "./components/blog";
import "./components/menu";
import "./profiles/user-menu";
import "./profiles/welcome";
import createComponent from "./vue";
import appPopups from "./popups/app-popups";
import bottomPopup from "./components/bottom-popup";
import labeledInput from "./components/labeled-input";

import analytics from "./marketing/analytics";
import dom from "./dom";

const attachGoalsToLinks = () => {
    const linksToAttachGoals = [...document.querySelectorAll(".js-goal")];
    const uniqGoalNames = [...new Set(
        linksToAttachGoals
            .map(link => link.dataset.source),
    )];

    uniqGoalNames.forEach(goalName => {
        const selector = `.js-goal[data-source="${goalName}"]`;
        analytics.reachGoalOnClick(selector, goalName);
    });
};

dom.callAfterLoaded(async () => {
    await analytics.init();
    attachGoalsToLinks();
    analytics.fireNotBounceOnEvent(".js-not-bounce-form input", "input");
});

createComponent(appPopups, "#app-popups");
createComponent({ components: { labeledInput } }, ".js-newsletter-form");

createComponent({
    components: { bottomPopup },
    name: "ONBOARDING",
}, "#js-bottom-popup");

export default {};
